module.exports = __webpack_public_path__ + "static/media/icon-instagram.46cbb278.svg";